import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Enlightenment_&_Revolutions_-_American_Revolution.png';

function HistoryPageAmericanRevolutionGo() {
  return (
    <QuizPage
      title="History: American Revolution"
      subTopic="American Revolution"
      backgroundImage={historyImage}
      returnPath="/History-American-Revolution"
    />
  );
}

export default HistoryPageAmericanRevolutionGo;
